import { api } from "@/lib/apiClient";

const KEY = "xcelio_ref";

export function captureRef() {
  try {
    const q = new URLSearchParams(window.location.search);
    const code = q.get("ref");
    if (!code) return;
    const path = window.location.pathname.split("/")[1];
    const channel = q.get("ch") || (["invite", "gift", "moment"].includes(path) ? path : "direct");
    localStorage.setItem(KEY, code.toUpperCase());
    localStorage.setItem(`${KEY}_ch`, channel);
    if (sessionStorage.getItem(`${KEY}_clicked`) === code) return;
    sessionStorage.setItem(`${KEY}_clicked`, code);
    api.post("/partner/click", { code, channel }).catch(() => {});
  } catch {}
}

export const storedRef = () => { try { return localStorage.getItem(KEY) || null; } catch { return null; } };

export const storedChannel = () => { try { return localStorage.getItem(`${KEY}_ch`) || null; } catch { return null; } };

export const storeGift = (rid) => { try { localStorage.setItem(`${KEY}_gift`, rid); } catch {} };
export const storedGift = () => { try { return localStorage.getItem(`${KEY}_gift`) || null; } catch { return null; } };
